import React from "react";
import { Form, Input, Button } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle, faMinusCircle } from "@fortawesome/free-solid-svg-icons";

const CustomInputNumber = ({
  name,
  label,
  min = 0,
  max = 9,
  defaultValue = 1,
  form,
}) => {
  return (
    <div className="flex flex-col w-full">
      {label}
      <div
        className="h-[48px] flex items-center  px-3 py-1 w-full rounded-[8px] max-w-[110px] bg-[#F5F6F6]"
        style={{ border: "1px solid #d9d9d9" }}
      >
        <Button
          className="mr-1 border-0 p-0 "
          style={{ width: "10px", height: "10px" }}
          onClick={() => {
            const currentVal = form.getFieldValue(name);
            if (currentVal > min) {
              form.setFieldsValue({
                [name]: currentVal - 1,
              });
            }
          }}
        >
          <svg
            width="16"
            height="4"
            viewBox="0 0 16 4"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="text-primary"
          >
            <path
              d="M15 0H1C0.447715 0 0 0.447715 0 1V3C0 3.55228 0.447715 4 1 4H15C15.5523 4 16 3.55228 16 3V1C16 0.447715 15.5523 0 15 0Z"
              fill="currentColor"
            />
          </svg>
        </Button>

        <Form.Item
          className="mb-0 grow"
          name={name}
          initialValue={defaultValue}
        >
          <Input
            type="number"
            min={min}
            max={max}
            className="text-center text-[15px] font-semibold"
            value={form.getFieldValue(name)}
            variant="borderless"
          />
        </Form.Item>

        <Button
          className="ml-1 border-0 p-0 "
          style={{ width: "10px", height: "10px" }}
          onClick={() => {
            const currentVal = form.getFieldValue(name);
            if (currentVal < max) {
              form.setFieldsValue({
                [name]: currentVal + 1,
              });
            }
          }}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            className="text-primary"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17 8H12V3C12 2.73478 11.8946 2.48043 11.7071 2.29289C11.5196 2.10536 11.2652 2 11 2H9C8.73478 2 8.48043 2.10536 8.29289 2.29289C8.10536 2.48043 8 2.73478 8 3V8H3C2.73478 8 2.48043 8.10536 2.29289 8.29289C2.10536 8.48043 2 8.73478 2 9V11C2 11.2652 2.10536 11.5196 2.29289 11.7071C2.48043 11.8946 2.73478 12 3 12H8V17C8 17.2652 8.10536 17.5196 8.29289 17.7071C8.48043 17.8946 8.73478 18 9 18H11C11.2652 18 11.5196 17.8946 11.7071 17.7071C11.8946 17.5196 12 17.2652 12 17V12H17C17.2652 12 17.5196 11.8946 17.7071 11.7071C17.8946 11.5196 18 11.2652 18 11V9C18 8.73478 17.8946 8.48043 17.7071 8.29289C17.5196 8.10536 17.2652 8 17 8Z"
              fill="currentColor"
            />
          </svg>
        </Button>
      </div>
    </div>
  );
};

export default CustomInputNumber;
